import { SET_SELECTED_GPT_MODAL, SET_SELECTED_AGENT, SET_RBAC_DATA, SET_WEB_SEARCH_ENABLED, SET_FILE_UPLOADED, SET_NPS_POPUP_VISIBILITY, SET_SIDEBAR_COLLAPSED, SET_THINKING_ENABLED, SET_SELECTED_THREAD_NAME, SET_CATEGORY_PROMPTS, SET_SELECTED_TOOL, SET_SELECTED_LANGUAGE, SET_TALENT_PULSE_WEB_SEARCH_ENABLED } from "./actionTypes";

export const setSelectedGPTModal = (modalName) => ({
  type: SET_SELECTED_GPT_MODAL,
  payload: modalName,
});

export const setSelectedAgent = (agentName) => ({
  type: SET_SELECTED_AGENT,
  payload: agentName,
});

export const setRbacData = (rbacData) => ({
  type: SET_RBAC_DATA,
  payload: rbacData,
});

export const setWebSearchEnabled = (isEnabled) => ({
  type: SET_WEB_SEARCH_ENABLED,
  payload: isEnabled,
});

export const setTalentPulseWebSearchEnabled = (isEnabled) => ({
  type: SET_TALENT_PULSE_WEB_SEARCH_ENABLED,
  payload: isEnabled,
});

export const setFileUploaded = (isUploaded) => ({
  type: SET_FILE_UPLOADED,
  payload: isUploaded,
});

export const setNpsPopupVisibility = (isVisible) => ({
  type: SET_NPS_POPUP_VISIBILITY,
  payload: isVisible,
});

export const setSidebarCollapsed = (isCollapsed) => ({
  type: SET_SIDEBAR_COLLAPSED,
  payload: isCollapsed,
});

export const setThinkingEnabled = (isEnabled) => ({
  type: SET_THINKING_ENABLED,
  payload: isEnabled,
});

export const setSelectedThreadName = (threadData) => {
  if (threadData) {
    localStorage.setItem("selectedThreadName", JSON.stringify(threadData));
  } else {
    localStorage.removeItem("selectedThreadName");
  }
  return {
    type: SET_SELECTED_THREAD_NAME,
    payload: threadData,
  };
};

export const setCategoryPrompts = (prompts) => ({
  type: SET_CATEGORY_PROMPTS,
  payload: prompts,
});

export const setSelectedTool = (toolName) => ({
  type: SET_SELECTED_TOOL,
  payload: toolName,
});

export const setSelectedLanguage = (language) => ({
  type: SET_SELECTED_LANGUAGE,
  payload: language,
});
